import { createContext, useState, useContext, useEffect, useReducer } from "react";
import axios from "axios";
import {
  HomeReducer, 
  AboutReducer, 
  ContactReducer, 
  CustomizedReducer, 
  WhyChooseUsReducer, 
  PrivacyPolicyReducer, 
  TermAndConditionReducer, 
  FaqsReducer,
  OurCollectionsReducer
} from "../reducer/Reducer"; 

const AppContext = createContext();

//const domainURL = "https://promovara.aamirsaeed.com";
//const domainURLCMS = "https://cms.promovara.aamirsaeed.com";

//const domainURL = "http://localhost:5173";
//const domainURLCMS = "https://cms.promovara.aamirsaeed.com";

//const domainURL = "https://promovara.com";
const domainURL = "http://localhost:5173";
const domainURLCMS = "https://cms.promovara.com";

const homeAPI = "93bf9f93-c762-4df5-96da-bb0e0b963d85"; 
const AboutAPI="ce806bf7-a1a8-4677-90ce-6d3a3ba6fc0d";
const contactAPI = "deb30888-8374-47e4-b0e1-cef26aa44b77"; 
const CustomizedAPI = "b138bb99-1ad7-416f-927d-d9aa69f06a07";
const WhyChooseUsAPI = "744b4c05-6103-4d97-92c1-80f061feed49";
const PrivacyPlicyAPI = "501b1229-e495-4379-9f9a-2d0cb4667065";
const TermAndConditionAPI = "a3007bd7-ee87-46bc-974c-ec0c903036d7";
const FaqAPI = "efed2769-8269-4467-b72d-063243b64e88";
const OurCollectionsAPI = "37645cee-4f27-4366-b1d5-3237ce4cd726";

const initialStateHome = {
  isLoading: false,
  isError: false,
  HomeData: {},
}; 
const initialstateabout = {
  isLoading: false,
  isError: false,
  AboutData: {},
};
const initialStateContact = {
  isLoading: false,
  isError: false,
  ContactData: {},
};
const initialstateCustomized = {
  isLoading: false,
  isError: false,
  CustomizedData: {},
}; 
const initialstateWhychooseUs = {
  isLoading: false,
  isError: false,
  whychooseUsData: {},
}; 
const initialstatePrivacyPolicy = {
  isLoading: false,
  isError: false,
  PrivacyPolicyData: {},
}; 
const initialstateTermAndCondition = {
  isLoading: false,
  isError: false,
  TermAndConditionData: {},
}; 
const initialstateFaqs = {
  isLoading: false,
  isError: false,
  FaqsData: {},
};
const initialstateOurCollections = {
  isLoading: false,
  isError: false,
  OurCollectionsData: [],

  isCollectionCategoriesLoading: false,
  CollectionCategoriesData: [],
  
  isSingleLoading: false,
  SingleCollectionData: {}
}; 
const AppProvider = ({ children }) => {
  const [statehome, homedispatch] = useReducer(HomeReducer, initialStateHome);
  const [aboutstate, aboutdispatch] = useReducer(AboutReducer, initialstateabout);
  const [statecontact, contactdispatch] = useReducer(ContactReducer, initialStateContact);
  const [customizedstate, customizeddispatch] = useReducer(CustomizedReducer, initialstateCustomized);
  const [whyChooseUsstate, whyChooseUsdispatch] = useReducer(WhyChooseUsReducer, initialstateWhychooseUs);
  const [privacyPolicystate, privacyPolicydispatch] = useReducer(PrivacyPolicyReducer, initialstatePrivacyPolicy);
  const [termAndConditionstate, termAndConditiondispatch] = useReducer(TermAndConditionReducer, initialstateTermAndCondition);
  const [faqstate, faqdispatch] = useReducer(FaqsReducer, initialstateFaqs);
  const [ourcollectionsstate, ourcollectionsdispatch] = useReducer(OurCollectionsReducer, initialstateOurCollections); 

  const getHomeDATA = async (url) => {
    const username = '11202953';
    const password = '60-dayfreetrial';
    const authHeader = 'Basic ' + btoa(`${username}:${password}`);

    homedispatch({ type: 'SET_LOADING' });

    try {
      const response = await axios.get(url, {
        headers: { 'Authorization': authHeader },
      });
      homedispatch({ type: 'SET_DATA', payload: response.data });
    } catch (error) {
      if (error.response) {
        homedispatch({ type: 'ERROR_RESPONSE' });
      } else if (error.request) {
        homedispatch({ type: 'ERROR_REQUEST' });
      } else {
        homedispatch({ type: 'ERROR_MESSAGE' });
      }
    }
  }; 
  const getAboutDATA = async (url) => { 

    // Your username and password
    const username = '11202953';
    const password = '60-dayfreetrial';

    // Encode credentials to base64
    const authHeader = 'Basic ' + btoa(username + ':' + password).toString('base64');

    //console.log(data);
    aboutdispatch({type: 'SET_LOADING'});

      // Make the GET request with Basic Authentication
      await axios.get(url).then(response => {
        // Handle successful response
        const AboutData = response.data;

        aboutdispatch({type: 'SET_DATA', payload: AboutData});
       
      })
      .catch(error => {
        if (error.response) {
          // The server responded with a status code outside the 2xx range
          //console.log('Error response:', error.response);
          aboutdispatch({type: 'ERROR_RESPONSE'});
        } else if (error.request) {
          // The request was made but no response was received
          //console.log('Error request:', error.request);
          aboutdispatch({type: 'ERROR_REQUEST'});
        } else {
          // Something happened in setting up the request that triggered an error
          //console.log('Error message:', error.message);
          aboutdispatch({type: 'ERROR_MESSAGE'});
        }
      });
 
  };
  const getContactDATA = async (url) => { 
    
    const username = '11202953';
    const password = '60-dayfreetrial';
    const authHeader = 'Basic ' + btoa(`${username}:${password}`);

    contactdispatch({ type: 'SET_LOADING' });

    try {
      const response = await axios.get(url, {
        headers: { 'Authorization': authHeader },
      });
      contactdispatch({ type: 'SET_DATA', payload: response.data });
    } catch (error) {
      if (error.response) {
        contactdispatch({ type: 'ERROR_RESPONSE' });
      } else if (error.request) {
        contactdispatch({ type: 'ERROR_REQUEST' });
      } else {
        contactdispatch({ type: 'ERROR_MESSAGE' });
      }
    }
  }; 
  const getCustomizedDATA= async (url) => {
    const username = '11202953';
    const password = '60-dayfreetrial';
    const authHeader = 'Basic ' + btoa(`${username}:${password}`);

    customizeddispatch({ type: 'SET_LOADING' });

    try {
      const response = await axios.get(url, {
        headers: { 'Authorization': authHeader },
      });
      customizeddispatch({ type: 'SET_DATA', payload: response.data });
    } catch (error) {
      if (error.response) {
        customizeddispatch({ type: 'ERROR_RESPONSE' });
      } else if (error.request) {
        customizeddispatch({ type: 'ERROR_REQUEST' });
      } else {
        customizeddispatch({ type: 'ERROR_MESSAGE' });
      }
    }

  }; 
  const getwhyChooseUsDATA= async (url) => {
    const username = '11202953';
    const password = '60-dayfreetrial';
    const authHeader = 'Basic ' + btoa(`${username}:${password}`);

    whyChooseUsdispatch({ type: 'SET_LOADING' });

    try {
      const response = await axios.get(url, {
        headers: { 'Authorization': authHeader },
      });
      whyChooseUsdispatch({ type: 'SET_DATA', payload: response.data });
    } catch (error) {
      if (error.response) {
        whyChooseUsdispatch({ type: 'ERROR_RESPONSE' });
      } else if (error.request) {
        whyChooseUsdispatch({ type: 'ERROR_REQUEST' });
      } else {
        whyChooseUsdispatch({ type: 'ERROR_MESSAGE' });
      }
    }

  }; 
  const getPrivacyPolicyDATA= async (url) => {
    const username = '11202953';
    const password = '60-dayfreetrial';
    const authHeader = 'Basic ' + btoa(`${username}:${password}`);

    privacyPolicydispatch({ type: 'SET_LOADING' });

    try {
      const response = await axios.get(url, {
        headers: { 'Authorization': authHeader },
      });
      privacyPolicydispatch({ type: 'SET_DATA', payload: response.data });
    } catch (error) {
      if (error.response) {
        privacyPolicydispatch({ type: 'ERROR_RESPONSE' });
      } else if (error.request) {
        privacyPolicydispatch({ type: 'ERROR_REQUEST' });
      } else {
        privacyPolicydispatch({ type: 'ERROR_MESSAGE' });
      }
    }

  }; 
  const getTermAndConditionDATA= async (url) => {
    const username = '11202953';
    const password = '60-dayfreetrial';
    const authHeader = 'Basic ' + btoa(`${username}:${password}`);

    termAndConditiondispatch({ type: 'SET_LOADING' });

    try {
      const response = await axios.get(url, {
        headers: { 'Authorization': authHeader },
      });
      termAndConditiondispatch({ type: 'SET_DATA', payload: response.data });
    } catch (error) {
      if (error.response) {
        termAndConditiondispatch({ type: 'ERROR_RESPONSE' });
      } else if (error.request) {
        termAndConditiondispatch({ type: 'ERROR_REQUEST' });
      } else {
        termAndConditiondispatch({ type: 'ERROR_MESSAGE' });
      }
    }

  }; 
  const getFaqsDATA= async (url) => {
    const username = '11202953';
    const password = '60-dayfreetrial';
    const authHeader = 'Basic ' + btoa(`${username}:${password}`);

    faqdispatch({ type: 'SET_LOADING' });

    try {
      const response = await axios.get(url, {
        headers: { 'Authorization': authHeader },
      });
      faqdispatch({ type: 'SET_DATA', payload: response.data });
    } catch (error) {
      if (error.response) {
        faqdispatch({ type: 'ERROR_RESPONSE' });
      } else if (error.request) {
        faqdispatch({ type: 'ERROR_REQUEST' });
      } else {
        faqdispatch({ type: 'ERROR_MESSAGE' });
      }
    }

  };
  
  const getourcollectionsDATA= async (url) => {
    const username = '11202953';
    const password = '60-dayfreetrial';
    const authHeader = 'Basic ' + btoa(`${username}:${password}`);

    ourcollectionsdispatch({ type: 'SET_LOADING' });

    try {
      const response = await axios.get(url, {
        headers: { 'Authorization': authHeader },
      });
      ourcollectionsdispatch({ type: 'SET_DATA', payload: response.data });
    } catch (error) {
      if (error.response) {
        ourcollectionsdispatch({ type: 'ERROR_RESPONSE' });
      } else if (error.request) {
        ourcollectionsdispatch({ type: 'ERROR_REQUEST' });
      } else {
        ourcollectionsdispatch({ type: 'ERROR_MESSAGE' });
      }
    }

  };

  const getcollectioncategoriesDATA= async (url) => { 

    ourcollectionsdispatch({ type: 'SET_CATEGORIES_LOADING' });

    try {
      const response = await axios.get(url);
      ourcollectionsdispatch({ type: 'SET_CATEGORIES_DATA', payload: response.data });
    } catch (error) {
      if (error.response) {
        ourcollectionsdispatch({ type: 'ERROR_CATEGORIES_RESPONSE' });
      }
    }

  };

  const getsinglecollectionDATA= async (url) => {
    
    ourcollectionsdispatch({ type: 'SET_SINGLE_LOADING' });

    try {
      const response = await axios.get(url); 
      ourcollectionsdispatch({ type: 'SET_SINGLE_DATA', payload: response.data });
    } catch (error) {
      ourcollectionsdispatch({ type: 'ERROR_SINGLE_RESPONSE' });
    }

  };
  useEffect(() => {
    const urlHome = `${domainURLCMS}/umbraco/delivery/api/v2/content/Item/${homeAPI}?expand=properties[$all]`;
    getHomeDATA(urlHome); 
    const urlAbout = `${domainURLCMS}/umbraco/delivery/api/v2/content/Item/${AboutAPI}?expand=properties[$all]`;
    getAboutDATA(urlAbout);
    const urlContact = `${domainURLCMS}/umbraco/delivery/api/v2/content/Item/${contactAPI}?expand=properties[$all]`;
    getContactDATA(urlContact);
    const urlCustomized = `${domainURLCMS}/umbraco/delivery/api/v2/content/?fetch=children:${CustomizedAPI}&expand=properties[$all]&skip=0&take=500`;
    getCustomizedDATA(urlCustomized);
    const urlWhyChooseUS = `${domainURLCMS}/umbraco/delivery/api/v2/content/Item/${WhyChooseUsAPI}?expand=properties[$all]`;
    getwhyChooseUsDATA(urlWhyChooseUS);
    const urlPrivacyPolicy = `${domainURLCMS}/umbraco/delivery/api/v2/content/Item/${PrivacyPlicyAPI}?expand=properties[$all]`;
    getPrivacyPolicyDATA(urlPrivacyPolicy);
    const urlTermAndCondition = `${domainURLCMS}/umbraco/delivery/api/v2/content/Item/${TermAndConditionAPI}?expand=properties[$all]`;
    getTermAndConditionDATA(urlTermAndCondition);
    const urlFaqs = `${domainURLCMS}/umbraco/delivery/api/v2/content/Item/${FaqAPI}?expand=properties[$all]`;
    getFaqsDATA(urlFaqs);
    const urlOurCollections = `${domainURLCMS}/umbraco/delivery/api/v2/content/?fetch=descendants:${OurCollectionsAPI}&expand=properties[$all]&skip=0&take=500`;
    getourcollectionsDATA(urlOurCollections);
  }, []);

  return (
    <AppContext.Provider value={{ domainURL, domainURLCMS, myName: "Abbas Tahir", 
      ...statehome, 
      ...statecontact, 
      ...aboutstate, 
      ...customizedstate, 
      ...whyChooseUsstate, 
      ...privacyPolicystate, 
      ...termAndConditionstate,
      ...faqstate, 
      ...ourcollectionsstate,
      getsinglecollectionDATA,
      getcollectioncategoriesDATA }}>
      {children}
    </AppContext.Provider>
  );
};

// Custom hook
const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within an AppProvider");
  }
  return context;
};

export { AppProvider, AppContext, useAppContext };

// //Create a Context Api


// import { createContext, useState, useContext, useEffect, useReducer } from "react";
// import axios from "axios";
// import reducer from "../reducer/HomeReducer";

// const AppContextWorkLikeWareHouseStore = createContext();

// //const API = "http://promovara.aamirsaeed.com/umbraco/delivery/api/v2/content/?fetch=children:dd1975e1-c750-40e3-9645-9fdff2a4a55f";
// //const HomeAPI = "http://promovara.aamirsaeed.com/umbraco/delivery/api/v2/content/Item/93bf9f93-c762-4df5-96da-bb0e0b963d85";


// const HomeAPI = "93bf9f93-c762-4df5-96da-bb0e0b963d85"; 
// const ContactAPI = "deb30888-8374-47e4-b0e1-cef26aa44b77"; 

// const initialStateHome = {
//     isLoading: false,
//     isError: false,
//     HomeData: {},
//     //HotCategories: [],
// }

// const AppProviderWorkLikeAreaInStore = ({children}) => {
//     // State for the app
//     const [statehome, homedispatch] = useReducer(reducer, initialstate);
    
//     // const getHomeDATA= async () => {
        
//     //     homedispatch({type: 'SET_LOADING'});
 
//     //     axios.get('http://promovara.aamirsaeed.com/umbraco/delivery/api/v2/content/?fetch=children:dd1975e1-c750-40e3-9645-9fdff2a4a55f',
//     //       { auth: {
//     //     username: '11202953',
//     //     password: '60-dayfreetrial'
//     //   }})
//     //   .then(response => {
//     //     //console.log('Success response:', response);
//     //     const HomeData = response.data;
//     //     console.log(HomeData);
//     //     homedispatch({type: 'SET_DATA', payload: HomeData});
//     //   })
//     //   .catch(error => {
//     //     // if (error.response) {
//     //     //   // The server responded with a status code outside the 2xx range
//     //     //   console.log('Error response:', error.response);
//     //     // } else if (error.request) {
//     //     //   // The request was made but no response was received
//     //     //   console.log('Error request:', error.request);
//     //     // } else {
//     //     //   // Something happened in setting up the request that triggered an error
//     //     //   console.log('Error message:', error.message);
//     //     // }
//     //     if (error.response) {
//     //       // The server responded with a status code outside the 2xx range
//     //       console.log('Error response:', error.response);
//     //       homedispatch({type: 'ERROR_RESPONSE'});
//     //     } else if (error.request) {
//     //       // The request was made but no response was received
//     //       console.log('Error request:', error.request);
//     //       homedispatch({type: 'ERROR_REQUEST'});
//     //     } else {
//     //       // Something happened in setting up the request that triggered an error
//     //       console.log('Error message:', error.message);
//     //       homedispatch({type: 'ERROR_MESSAGE'});
//     //     }

//     //   });
      
//     // }

//   const getHomeDATA = async (url) => { 

//     // Your username and password
//     const username = '11202953';
//     const password = '60-dayfreetrial';

//     // Encode credentials to base64
//     const authHeader = 'Basic ' + btoa(username + ':' + password).toString('base64');


//     //console.log(data);
//     homedispatch({type: 'SET_LOADING'});


//     // await axios.get('https://658366114d1ee97c6bcdeb43.mockapi.io/abbas-api')
//     // .then(response => {
//     //     const HomeData = response.data;
//     //     console.log(HomeData);
//     //     homedispatch({type: 'SET_DATA', payload: HomeData});
//     // })
//     // .catch(error => {
//     //     console.error('Error:', error);
//     // });


//     // await axios.get(url, {
//     //     headers: {
//     //       'Authorization': authHeader,
//     //       //'Content-Type': 'application/json', 
//     //     }
//     //   })
//     // await axios.get(url, {
//     //     auth: {
//     //         username: '11202953',
//     //         password: '60-dayfreetrial'
//     //       //'Content-Type': 'application/json', 
//     //     }
//     //   })

//       // Make the GET request with Basic Authentication
//       await axios.get(url).then(response => {
//         // Handle successful response
//         const HomeData = response.data;

//         //console.log('Success response:', HomeData);
//         //setData(response.Users);
//         //navigation.navigate("login");
//         homedispatch({type: 'SET_DATA', payload: HomeData});
       
//       })
//       .catch(error => {
//         if (error.response) {
//           // The server responded with a status code outside the 2xx range
//           //console.log('Error response:', error.response);
//           homedispatch({type: 'ERROR_RESPONSE'});
//         } else if (error.request) {
//           // The request was made but no response was received
//           //console.log('Error request:', error.request);
//           homedispatch({type: 'ERROR_REQUEST'});
//         } else {
//           // Something happened in setting up the request that triggered an error
//           //console.log('Error message:', error.message);
//           homedispatch({type: 'ERROR_MESSAGE'});
//         }
//       });
 
//     };


//     useEffect(() => {
//         getHomeDATA(`http://promovara.aamirsaeed.com/umbraco/delivery/api/v2/content/Item/${HomeAPI}?expand=properties[$all]`)
//     },[])
//     //myName: "Abbas Tahir",

//     return <AppContextWorkLikeWareHouseStore.Provider value={{ myName: "Abbas Tahir", ...statehome  }}>{children}</AppContextWorkLikeWareHouseStore.Provider>

// }

// //Custom hook
// const useContextIsACustomHook = () => {
//     const context = useContext(AppContextWorkLikeWareHouseStore);
//     if (!context) {
//         throw new Error("useProductContext must be used within an AppProvider");
//     }
//     return context;
// }

// export {AppProviderWorkLikeAreaInStore, AppContextWorkLikeWareHouseStore, useContextIsACustomHook};